var ButtonMessagePopup = require("app/AppLayout/ButtonMessagePopup"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    icons              = require("app/theme/icons"),
    kind               = require("enyo/kind"),
    quickMacroize      = require("enyo/macroize").quickMacroize;

require("./FatalErrorView.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");
require("app/theme/styles/popups/ScrollerPopup--borderless.less");

module.exports = kind(/** @lends  app.MediaPlayer.FatalErrorView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.FatalErrorView",

    /**
     * @private
     */
    kind: ButtonMessagePopup,

    /**
     * @private
     */
    layoutOptions: {
        /**
         * Center in contentRegion when maximized, center on screen otherwise.
         *
         * @returns {string} The alignment
         */
        alignment: function() {
            return this.container.controller.get("displayMode") === "maximized"
                ? "contentRegion"
                : "fullLayout";
        },

        /**
         * Expand layout if player is maximized.
         *
         * @returns {boolean} Whether to expand the popup
         */
        expand: function() {
            return this.container.controller.get("displayMode") === "maximized";
        },

        /**
         * Overlap safe area if player is maximized.
         *
         * @returns {boolean} Whether to overlap the safe area
         */
        overlapSafeArea: function() {
            return this.container.controller.get("displayMode") === "maximized";
        },

        /**
         * Clear floating header if player is not maximized.
         *
         * @returns {boolean} Whether to clear floating header
         */
        clearFloatingHeader: false
    },

    /**
     * @private
     */
    classes: "app-media-player-fatal-error-view",

    /**
     * @private
     */
    showCloseButton: false,

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.button.set("icon", icons["app.MediaPlayer.FatalErrorView.button"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("controller.displayMode", this.resize);
            this.update();
        };
    }),

    /**
     * @private
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            if (this.controller.get("displayMode") === "maximized") {
                // Expanded popup is borderless
                this.set("theme", "borderless");
            }
            else {
                // Unexpanded popup is bordered
                this.set("theme", "bordered");
            }
            sup.apply(this, arguments);
        };
    }),

    /**
     * @private
     */
    afterMount: function() {
        if (this.controller.get("displayMode") === "maximized") {
            this.requestShow(true, true);
        }
        else {
            this.requestShow(true, false);
        }
    },

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.MediaPlayer.FatalError.title"));
        $message.$.body.set("content", i18nService.getString("app.MediaPlayer.FatalError.body"));
        $message.$.button.set("caption", i18nService.getString("app.MediaPlayer.FatalError.Button.caption"));
        $message.$.button.set("tooltip", i18nService.getString("app.MediaPlayer.FatalError.Button.tooltip"));
    },

    /**
     * The application must be reloaded in order to recover.
     *
     * @private
     */
    onMessageButtonTap: function() {
        var $router  = this.app.$.router,
            language = this.app.$.i18nService.get("language");

        $router.assign(quickMacroize("/{$language}/home", {
            language: language
        }));
    }

});
